// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"c825fb58","259":"3551325b","453":"a80f87b2","742":"df50dd4f","828":"5fe03e94","954":"f1c8acbf"}[chunkId] + ".chunk.js";
};